<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>测试列表</span>
          <el-button v-permisaction="['config:test:add']" type="primary" size="mini" style="margin-left: 16px;" @click="edit(formDataBak)">新增</el-button>
        </div>

        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >`
            <el-table-column
              prop="run_time"
              label="运行时长"
              align="center"
            />
            <el-table-column
              prop="end_time"
              label="结束时间"
              align="center"
            />
            <el-table-column
              prop="user"
              label="运行用户数量"
              align="center"
            />
            <el-table-column
              prop="is_buy_spins"
              label="是否自动增加体力"
              align="center"
              :formatter="isBuySpinsFormatter"
            />
            <el-table-column
              fixed="right"
              label="操作"
            >
              <template v-slot:default="scope">
                <el-button v-permisaction="['config:test:edit']" type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                <el-button v-if="scope.row.status === 0" v-permisaction="['config:test:edit']" type="text" size="small" @click="handle(scope.row.id,1)">启动</el-button>
                <el-button v-if="scope.row.status === 1" v-permisaction="['config:test:edit']" type="text" size="small" @click="handle(scope.row.id,2)">停止</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            background
            :page.sync="queryParams.pageIndex"
            :limit.sync="queryParams.pageSize"
            :total="total"
            @pagination="getTables"
          />
        </template>
      </el-card>

      <el-drawer
        title="配置"
        :visible.sync="drawer"
        size="700px"
        :before-close="handleClose"
      >
        <el-form ref="formData" :rules="rules" :model="formData" label-width="120px">
          <el-form-item label="运行时长(分钟)" prop="run_time" style="width: 400px;">
            <el-input v-model.number="formData.run_time" placeholder="运行时长(分钟)" />
          </el-form-item>
          <el-form-item label="用户数量" prop="user">
            <el-input v-model.number="formData.user" placeholder="用户数量" />
          </el-form-item>
          <el-form-item label="自动购买体力" prop="is_buy_spins">
            <el-select v-model.number="formData.is_buy_spins" placeholder="请选择">
              <el-option
                v-for="item in buyType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="自动购买数量" prop="buy_spin" style="width: 400px">
            <el-input v-model.number="formData.buy_spin" :disabled="formData.is_buy_spins === 0" placeholder="自动购买数量" />
          </el-form-item>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

    </template>
  </BasicLayout>
</template>

<script>
import { getTestList, handleStatus, updateTestCfg } from '@/api/test/test'

export default {
  name: 'ExchangeCode',
  data() {
    return {
      total: 0,
      rewardTypes: [],
      tableData: [],
      loading: false,
      drawer: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      statusType: [
        { label: '未运行', value: 0 },
        { label: '运行中', value: 1 },
        { label: '已结束', value: 2 }
      ],
      buyType: [
        { label: '否', value: 0 },
        { label: '是', value: 1 }
      ],
      formDataBak: {
        run_time: '',
        end_time: 0,
        user: 0,
        is_buy_spins: 0,
        buy_spin: '',
        status: 0
      },
      formData: {
        run_time: '',
        end_time: 0,
        user: 0,
        is_buy_spins: 0,
        buy_spin: '',
        status: 0
      },
      users: [],
      rules: {
        limit: [
          { required: true, message: '请输入可领取数量', trigger: 'blur' }
        ],
        expire: [
          { required: true, message: '请选择过期时间', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d) {
      this.drawer = false
    },
    edit(row) {
      this.formData = row
      this.drawer = true
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          if (_data.user <= 0) {
            this.msgError('运行用户数量不能小于0')
            return
          }

          const data = JSON.stringify(this.formData)
          updateTestCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.drawer = false
              this.formData = this.formDataBak
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getTables() {
      this.loading = true
      getTestList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.drawer = true
    },
    isBuySpinsFormatter(row, col, val) {
      if (val === 1) {
        return '是'
      } else {
        return '否'
      }
    },
    handle(id, status) {
      handleStatus({ id: id, name: status }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
